@if (showNotes) {
    <div class="note mt-5">
        <mat-checkbox class="mat-small mb-3" (change)="acceptNotes($event.checked)" [checked]="selectedNote">
            <strong> Please note: </strong> Payments made in error will need to be reviewed by AGI Cargo for final
            approval. This refund approval process can take up to 14 business days. If you suspect a refund is due
            please email payments&#64;agi.aero for assistance.
        </mat-checkbox>
        <mat-checkbox class="mat-small mb-3" (change)="acceptTermsOfUse($event.checked)" [checked]="selectedTermsOfUse">
            To continue, please accept our
            <a [href]="termsOfUseURL | sanitize: 'url'" target="_blank">
                <strong>Terms of Use</strong>
            </a>
        </mat-checkbox>
    </div>
}
